import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';

const GuardiaComponent = ({ sede }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const traeGuardiaHoy = async () => {
    try {
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveGuardia`,
        { sede: sede }
      );

      setData(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    traeGuardiaHoy();
  }, []);

  const obtenerAnio = (promocion) => {
    return promocion === '2026-2027' ? 'Primer Año' : 'Segundo Año';
  };

  const agruparPorPromocion = (cadetes) => {
    return cadetes?.reduce((grupo, cadete) => {
      const promocion = cadete?.cadete?.Promocions?.[0]?.nombre || cadete?.Promocions?.[0]?.nombre||'Sin promoción';
      if (!grupo[promocion]) {
        grupo[promocion] = [];
      }
      grupo[promocion].push(cadete);
      return grupo;
    }, {}) || {};
  };

  const exportarExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data.GrupoCadetesGuardia.map((cadete) => ({
      DNI: cadete?.cadeteDni || 'Sin DNI',
      Apellido: cadete?.cadete?.cadeteApellido || 'Sin apellido',
      Nombre: cadete?.cadete?.cadeteNombre || 'Sin nombre',
      Promoción: cadete?.cadete?.Promocions?.[0]?.nombre || 'Sin promoción',
      tipo:cadete?.tipo||''
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Guardia');
    XLSX.writeFile(wb, 'GuardiaCadetes.xlsx');
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const cadetesPorPromocion = agruparPorPromocion(data?.GrupoCadetesGuardia);
  const cadetesPresentes = agruparPorPromocion(data?.cadetesPresentes);
  const cadetesAusentes = agruparPorPromocion(data?.cadetesAusentes);

  return (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
      <h2 style={{ width: '100%', background: 'GrayText' }}>Información de Guardia ACTUAL</h2>
      <button onClick={exportarExcel} style={{ marginBottom: '20px', padding: '10px', background: '#28a745', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
        Exportar a Excel
      </button>
      {data && (
        <div style={{ width: '90%' }}>
          <h3 style={{ color: 'white', background: '#489' }}>Sede: {data.sede}</h3>
          <p>Total de cadetes del grupo de guardia: {data.totalCadetesGuardia}</p>



          <div>
            <h4>Cadetes presentes:</h4>
            {Object.entries(cadetesPresentes).length > 0 ? (
              Object.entries(cadetesPresentes).map(([promocion, cadetes]) => (
                <div key={promocion}>
                  <h5 style={{ color: '#fff', background: '#4b8' }}>Promoción: {promocion} ({obtenerAnio(promocion)})</h5>
                  <ul>
                   
                    {cadetes.map((cadete, index) => (
                      <li key={cadete?.cadeteDni || Math.random()}>
                        {index + 1}. {cadete?.cadeteApellido || 'Sin apellido'} {cadete?.cadeteNombre || 'Sin nombre'} - {cadete?.cadeteDni || 'Sin DNI'}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <p>No hay cadetes presentes.</p>
            )}
          </div>

          <div>
            <h4>Cadetes ausentes:</h4>
            {Object.entries(cadetesAusentes).length > 0 ? (
              Object.entries(cadetesAusentes).map(([promocion, cadetes]) => (
                <div key={promocion}>
                  <h5 style={{ color: '#fff', background: '#c44' }}>Promoción: {promocion} ({obtenerAnio(promocion)})</h5>
                  <ul>
                    {cadetes.map((ausente, index) => (
                      <li key={ausente?.cadeteDni || Math.random()}>
                        {index + 1}. {ausente?.cadete.cadeteApellido || 'Sin apellido'} {ausente?.cadete.cadeteNombre || 'Sin nombre'} - {ausente?.cadeteDni || 'Sin DNI'} - Tipo de ausencia: {ausente?.tipoAusencia || 'Sin tipo'}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <p>No hay cadetes ausentes.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GuardiaComponent;
